export default __webpack_public_path__ + "static/layout-dont-20c0485223b84d2f5e7c7dfbfbc34a71d4b214a28e8aec43e0e783457e372740.png";